var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',{attrs:{"action":_vm.action}},[_c('span',[_vm._v("\n    Add your gender\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }